import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import moment from 'moment';
import { convertArrToObj } from '../../utils/index';

/* Types & Action Creators */
const { Types, Creators } = createActions({
  // Requests actions
  requestInfos: [],
  requestAppointments: [],
  requestProfessionals: [],
  requestProfessional: ['id'],
  requestCancelAppointment: ['id'],
  requestStoreRating: ['appointmentId', 'rating', 'comments'],
  requestScheduleColumns: ['startDate', 'endDate', 'professional'],
  requestScheduleTimeTable: [],
  sendAppointment: [
    'timeTableId',
    'columnDate',
    'professionalId',
    'meetingId',
    'contact',
    'mainDoubt',
  ],
  // Handle store actions
  setInfos: ['infos'],
  setAppointments: ['appointmentsObj'],
  resetAppointments: [''],
  setProfessionals: ['professionalsObj'],
  setProfessional: ['professionalId', 'professionalInfos'],
  updateProfessional: ['professionalId', 'professionalInfos'],
  addAppointment: ['appointmentId', 'appointmentInfos'],
  updateAppointment: ['appointmentId', 'appointmentInfos'],
  setScheduleTimeTable: ['timetable'],
  addScheduleColumns: ['startDate', 'length'],
  resetScheduleColumns: [],
  updateScheduleColumns: ['columnsObj', 'professional'],
  updateNewAppointment: ['sending', 'id', 'error'],
});
export const AppointmentsTypes = Types;
export default Creators;

/* Initial State */
export const INITIAL_STATE = Immutable({
  infos: {
    loaded: false,
  },
  history: {
    list: {},
    allLoaded: false,
  },
  professionals: {
    list: {},
    allLoaded: false,
  },
  schedule: {
    columns: {
      timetable: {},
      list: {},
      allLoaded: false,
    },
    filters: {
      professional: null,
    },
  },
  new: {
    sending: false,
    id: null,
    error: '',
  },
});

const setInfos = (state = INITIAL_STATE, { infos }) =>
  Immutable.setIn(state, ['infos'], { ...infos, loaded: true });

const setAppointments = (state = INITIAL_STATE, { appointmentsObj }) =>
  Immutable.setIn(state, ['history'], {
    list: appointmentsObj,
    allLoaded: true,
  });

const resetAppointments = (state = INITIAL_STATE) =>
  Immutable.setIn(state, ['history'], {
    ...INITIAL_STATE.history,
  });

const setProfessionals = (state = INITIAL_STATE, { professionalsObj }) =>
  Immutable.setIn(state, ['professionals'], {
    list: professionalsObj,
    allLoaded: true,
  });

const setProfessional = (
  state = INITIAL_STATE,
  { professionalId, professionalInfos },
) =>
  Immutable.updateIn(state, ['professionals', 'list'], list =>
    Immutable.merge(list, {
      [professionalId]: {
        ...professionalInfos,
        error: false,
        allLoaded: true,
      },
    }),
  );

const updateProfessional = (
  state = INITIAL_STATE,
  { professionalId, professionalInfos },
) =>
  Immutable.updateIn(
    state,
    ['professionals', 'list', professionalId],
    professional => Immutable.merge(professional, professionalInfos),
  );

const addAppointment = (
  state = INITIAL_STATE,
  { appointmentId, appointmentInfos },
) =>
  Immutable.updateIn(state, ['history', 'list'], list =>
    Immutable.merge(list, { [appointmentId]: appointmentInfos }),
  );

const updateAppointment = (
  state = INITIAL_STATE,
  { appointmentId, appointmentInfos },
) =>
  Immutable.updateIn(state, ['history', 'list', appointmentId], appointment =>
    Immutable.merge(appointment, appointmentInfos),
  );

const setScheduleTimeTable = (state = INITIAL_STATE, { timetable }) =>
  Immutable.setIn(state, ['schedule', 'columns', 'timetable'], timetable);

const addScheduleColumns = (state = INITIAL_STATE, { startDate, length }) => {
  const newColumns = Array.from({ length }, (v, index) => {
    const date = moment(startDate)
      .utc()
      .startOf('day')
      .add(index, 'd')
      .toISOString(true);
    return {
      date,
      slots: [],
      loaded: false,
    };
  });
  const newColumnsObj = convertArrToObj(newColumns, 'date');
  return Immutable.updateIn(state, ['schedule', 'columns', 'list'], list =>
    Immutable.merge(list, newColumnsObj),
  );
};

const resetScheduleColumns = (state = INITIAL_STATE) =>
  Immutable.setIn(
    state,
    ['schedule', 'columns', 'list'],
    INITIAL_STATE.schedule.columns.list,
  );

const updateScheduleColumns = (
  state = INITIAL_STATE,
  { columnsObj, professional },
) =>
  Immutable.updateIn(state, ['schedule'], schedule =>
    Immutable.merge(schedule, {
      filters: Immutable.merge(schedule.filters, { professional }),
      columns: Immutable.updateIn(schedule.columns, ['list'], list =>
        Immutable.merge(list, columnsObj),
      ),
    }),
  );

const updateNewAppointment = (state = INITIAL_STATE, { sending, id, error }) =>
  Immutable.updateIn(state, ['new'], newAppointment =>
    Immutable.merge(newAppointment, {
      sending,
      id: id || INITIAL_STATE.new.id,
      error: error || INITIAL_STATE.new.error,
    }),
  );

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_INFOS]: setInfos,
  [Types.SET_APPOINTMENTS]: setAppointments,
  [Types.RESET_APPOINTMENTS]: resetAppointments,
  [Types.SET_PROFESSIONALS]: setProfessionals,
  [Types.SET_PROFESSIONAL]: setProfessional,
  [Types.UPDATE_PROFESSIONAL]: updateProfessional,
  [Types.ADD_APPOINTMENT]: addAppointment,
  [Types.UPDATE_APPOINTMENT]: updateAppointment,
  [Types.SET_SCHEDULE_TIME_TABLE]: setScheduleTimeTable,
  [Types.ADD_SCHEDULE_COLUMNS]: addScheduleColumns,
  [Types.RESET_SCHEDULE_COLUMNS]: resetScheduleColumns,
  [Types.UPDATE_SCHEDULE_COLUMNS]: updateScheduleColumns,
  [Types.UPDATE_NEW_APPOINTMENT]: updateNewAppointment,
});
